/*eslint-disable*/
import store from '@/store';
const tenantCode = store.getters.currentTenant.tenantCode;
import { positiveThirteenAndSix } from '@/modules/mdm/utils/regList.js'
import { options } from 'less';
// 表单配置信息
export const collapse = [

    {
        title: '目标变更信息',
        ref: 'changeForm',
        formName: 'changeInfo',
        col: 4,
        labelWidth: '170px',
        visible: true,
        formList: [
            {
                label: '申请编码',
                prop: 'goalChangeCode',
                type: 'custom',
            },

            {
                label: '申请日期',
                prop: 'changeTime',
                type: 'custom',
                span: 6,
            },
            {
                label: '变更申请原因',
                prop: 'changeReason',
                sourceType: 'input',
                inputType: 'textarea',
                placeholder: '（空）',
                type: 'input',
                disabled: true,
                span: 22,
                rows: 4,
            },
            {
                label: '附件',
                prop: 'changeFile',
                value: 'changeFile',
                type: 'custom',
                rule: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (rule.required && !value.length) {
                            callback(new Error('附件不能为空'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'change'
                }],
                span: 24
            },
        ]
    },

    {
        title: '目标变更明细',
        ref: 'detailForm',
        formName: 'detailInfo',
        col: 4,
        labelWidth: '0px',
        visible: true,
        formList: [
            {
                label: '',
                prop: 'detailList',
                value: 'detailList',
                type: 'custom',
                span: 24,
                columns: [
                    {
                        label: '年份',
                        minWidth: 120,
                        prop: 'goalYear',
                    },
                    {
                        label: '具体对象',
                        prop: 'targetObjectDetail',
                        minWidth: 120,
                    },
                    {
                        label: '目标大类',
                        prop: 'targetClass',
                        type: 'select',
                        optionsKey: 'NEOCRM_BUSINESS_TYPE',
                        minWidth: 120
                    },
                    {
                        label: '目标小类',
                        prop: 'targetSubclass',
                        // type: 'select',
                        // optionsKey: 'SYS_BMS_BUSI_TYPE',
                        minWidth: 120
                    },
                    {
                        label: '责任制类型',
                        prop: 'goalRole',
                        type: 'select',
                        optionsKey: 'NEOCRM_WH_TYPE',
                        minWidth: 160
                    },
                    {
                        label: '目标变更起始月份',
                        minWidth: 160,
                        prop: 'changeMonthStart',
                    },
                    {
                        label: '旧-目标值',
                        prop: 'yearGoalAs',
                        minWidth: 120
                    },
                    {
                        label: '新-目标值',
                        prop: 'yearGoal',
                        minWidth: 120
                    },
                ]
            },
        ]
    },
];
